//=include lib/jquery.min.js

(function($, window, document) {

  // Global navigation SP
    (function () {

      var siteNav = {

        el: {
          $toggle: $('.js_nav-toggle'),
          $wrapperOuter: $('.page'),
          $wrapper: $('.o-wrapper'),
          $overlay: $('.js_nav-overlay'),
          $navLinks: $('.nav-sp-list-item a')
        },

        config: {
        },

        init: function () {
          this.menuClickHandler();
          this.linkClickHandler();
        },

        menuClickHandler: function () {
          var _this = this;

          this.el.$toggle.on('click', function (e) {
            e.preventDefault();

            _this.toggleNav();

            return 0;
          });
        },

        linkClickHandler: function () {
          var _this = this;

          this.el.$navLinks.on('click', function (e) {
            _this.toggleNav();
          });
        },

        toggleNav: function () {
          var _this = this;
          var animationTime = 500;

          _this.toggleSliding();
          _this.toggleOverlay();

        },

        toggleOverlay: function () {
          this.el.$overlay.toggleClass('active');
        },

        toggleSliding: function () {
          this.el.$wrapper.toggleClass('nav-active');
        },

        toggleFixedScreen: function () {
          this.el.$wrapperOuter.toggleClass('nav-active');
        }

      };

      siteNav.init();

    })();

    (function () {

      $('.scroll-top').click(function(){
      $('html, body').animate({scrollTop : 0},800);
      return false;
    });


    })();

    (function () {

      $( '.js_link' ).on( 'click', function(e) {
        e.preventDefault();
        var posAdjustment = 0;

        if ($(this).hasClass('js_link1')) {
          posAdjustment = 200;
        } else if ($(this).hasClass('js_link2')) {
          posAdjustment = -50;
        } else if ($(this).hasClass('js_link3')) {
          posAdjustment = 130;
        } else if ($(this).hasClass('js_link4')) {
          posAdjustment = -220;
        }

        var target = $(this).attr('href');
        var offset = $( target ).offset().top + posAdjustment;
        $('html,body').animate({ scrollTop: offset }, 700);
        return 0;
      });

    })();


})(window.jQuery, window, document);
